import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import { DEFAULT_DRAWER_WIDTH, LG_DRAWER_WIDTH, MD_DRAWER_WIDTH, SM_DRAWER_WIDTH } from '../Sidebar/Drawer';

export const DEFAULT_TOOLBAR_HEIGHT = 64;
export const DEFAULT_YELLOW_LINE = 3;

export default makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: `${theme.zIndex.drawer + 1} !important`,
  },
  logo: {
    width: DEFAULT_DRAWER_WIDTH,
    [theme.breakpoints.down('xl')]: {
      width: LG_DRAWER_WIDTH,
    },
    [theme.breakpoints.down('lg')]: {
      width: MD_DRAWER_WIDTH,
    },
    [theme.breakpoints.down('md')]: {
      width: SM_DRAWER_WIDTH,
    },
    display: 'flex',
    justifyContent: 'center',
  },
  title: {
    color: 'white',
    fontWeight: 'normal',
    flex: '1',
    fontSize: '1.5rem',
    paddingLeft: theme.spacing(3),
  },
  toolbar: {
    padding: '0 !important',
    background: theme.palette.neutral[400],
  },
  yellowBar: {
    backgroundColor: theme.palette.primary.main,
    height: `${DEFAULT_YELLOW_LINE}px`,
  },
}));
